import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"


export default () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "vale-cursive-full.png" }) {
        childImageSharp {
          fixed(width: 140, height: 63) {
            ...GatsbyImageSharpFixed
          }
        }
      }
    }
  `)
  return <Img fixed={data.file.childImageSharp.fixed} />
}
